<template>
  <div>
    <div style="margin:0 auto;position:relative">
      <div>
        <img src="static/img/qrcode-bg.png" style="width:100%" />
        <p
          style="transform: translateX(-50%);font-size:12px;position:absolute;width:75%;text-align:center;left:50%;bottom: 19.5%;word-break: break-all;"
        >
          请您继续使用电脑访问
          <span @click="toMaster">https://user.ippmaster.com</span>进行智能算稅和一键申报！
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    document.title = '注册成功-麦德通'
  },
  methods: {
    toMaster() {
      window.location.href='https://user.ippmaster.com/'
    }
  }
}
</script>
<style scoped>
@import "../assets/css/animate.min.css";
@import "../assets/css/index.css";
</style>



// WEBPACK FOOTER //
// src/views/success.vue